import {LitElement, html, CSSResult, unsafeCSS} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import styles from './step-two.scss';
import {consume} from "@lit/context";
import {i18nContext} from "./i18nContext.js";
import {Messages, ArticleWithStoreStock} from "../../@types/online-reservation.js";

@customElement('step-two')
export class StepTwo extends LitElement {

  @property({ type: Function }) onNext!: () => void;

  @property({ type: Function }) selectSize!: (size: string) => void;

  @property({type: Array})
  private readonly sizesWithStoreStock: ArticleWithStoreStock[] = [];

  @consume({context: i18nContext})
  private readonly messages!: Messages;

  static get styles(): CSSResult {
    return unsafeCSS(styles);
  }

  render() {
    return html`
      <h2 class="ents-or__reservation-header ents-heading-medium" data-test-ents-or-steptwo-header>${this.messages['stepTwoHeader']}</h2>
      <div class="ents-or__sizelist">
        ${this.sizesWithStoreStock.map((size: ArticleWithStoreStock) => this.renderItem(size.value, size.id))}
      </div>
    `;
  }

  private renderItem(size: string, id: string) {
    return html`
      <label class="ents-copy-small-bold ents-or__item" data-test-ents-or-size-item>
        <input type="checkbox"
               @click="${this.selectItem(id)}"
               @keydown.enter="${this.selectItem(id)}"
               value="${size}"
               data-test-ents-or-next-button="${size}"
        />
        <div class="ents-or__size">
          <div class="ents-or__size-information" data-test-ents-or-size-item-text>
            <span>${size}</span>
          </div>
        </div>
      </label>
    `;
  }

  private selectItem(id: string) {
    return () => {
      this.selectSize(id);
      this.onNext();
    };
  }
}
